<template>
  <Modal :id="'editActContentModal'" :savePromise="save" :prepareFunc="prepare">
    <template #button>
      <a class='btn-edit' style="cursor: pointer;"><i class='fa fa-edit'></i>編輯</a>
    </template>
    <template #content>
      <div class="modal-body">
        <form :id="'editForm' + id">
          <div class="form-group">
            <h4 style="text-align: center;">任務名稱*</h4>
            <div class="mdl-textfield mdl-js-textfield">
              <input class="mdl-textfield__input" type="text" v-model="title" id="title" name="title" />
              <label class="mdl-textfield__label" for="title"></label>
            </div>
          </div>
          <div class="form-group">
            <h4 style="text-align: center;">簡介（選填）</h4>
            <textarea class="form-control" id="edit_week_description" name="description" rows="9" v-model="description"></textarea>
          </div>
        </form>
      </div>
      <div class="form-group row" style="padding-bottom: 30px;">
        <div class="col-xs-6" style="text-align: center;">
           <el-button plain data-dismiss="modal">取消</el-button>
        </div>
        <div class="col-xs-6" style="text-align: center;">
           <el-button class="save-btn" type="primary" data-dismiss="modal">儲存</el-button>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/Utility/Modal'

import $ from 'jquery'
export default {
  components: {
    Modal
  },
  props: {
    week: Object
  },
  data () {
    return {
      title: this.week.title,
      description: this.week.description,
      save: async (modal, e) => {
        console.log(this)
        let fd = new FormData(modal.find('form')[0])
        try {
          await this.$store.dispatch('request', {
            method: 'post',
            route: `courses/${this.courseId}/weeks/${this.id}`,
            data: fd
          })
          this.$parent.updateWeek({
            title: fd.get('title'),
            description: fd.get('description')
          })
          return true
        } catch (err) {
          console.error(err)
          return false
        }
      },
      prepare: () => {
        this.title = this.week.title
        this.description = this.week.description
      }
    }
  },
  computed: {
    courseId: function () {
      return parseInt(this.$parent.courseId)
    },
    id: function () {
      return parseInt(this.$parent.id)
    },
    modalId: function () {
      return '#editActContentModal' + this.id
    }
  },
  methods: {
    edit: function (e) {
      let fd = new FormData(document.getElementById('editForm' + this.id))
      try {
        this.$store.dispatch('request', {
          method: 'post',
          route: `courses/${this.courseId}/weeks/${this.id}`,
          data: fd
        }).then(result => {
          alert('成功')
          this.$parent.updateWeek({
            title: fd.get('title'),
            description: fd.get('description')
          })
          $(this.modalId).modal('hide')
        })
      } catch (err) {
        alert('失敗')
      }
    }
  },
  mounted () {
    $(this.modalId).on('show.bs.modal', () => {
      this.title = this.week.title
      this.description = this.week.description
    })
    $(this.modalId).on('hide.bs.modal', () => {
      this.title = this.week.title
      this.description = this.week.description
    })
  }
}
</script>
